// extracted by mini-css-extract-plugin
export default {"bringgAlert":"alert_bringgAlert__nfbKf","info":"alert_info__P6MnS","warning":"alert_warning__M0nXw","error":"alert_error__8eODR","success":"alert_success__NMjmb"};